import { ADMIN_ROLES } from "../../auth";
import { ApplicationState } from "../../applicationState";

import { teamSelector } from "./selectors";

export const routeName = "teams";

export const routes = {
    [`/${routeName}`]: {
        title: "Teams",
        authorize: [ADMIN_ROLES.SYSTEM_ADMIN.name],
        "/create": {
            title: "Create Team"
        },
        "/:teamId": {
            title: (state: ApplicationState) => teamSelector(state)?.name ?? "Team",
            "/edit": {
                title: "Edit",
            }
        }
    }
};
